<template>
  <div class="flex w-full h-full py-5 xl:h-auto xl:py-0 xl:my-0 xl:max-w-148.5">
    <div
      :class="`${prefixCls}-form`"
      class="relative w-full px-5 py-8 my-auto rounded-md shadow-md lg:ml-auto lg:bg-transparent lg:px-8 lg:shadow-none enter-x"
    >
      <CheckAccount :currentRoute="currentRoute" :is-modal="true" />
      <LoginForm :currentRoute="currentRoute" />
      <ForgetPasswordForm />
      <RegisterForm />
      <MobileForm />
    </div>
  </div>
</template>
<script setup lang="ts">
  import CheckAccount from './CheckAccount.vue';
  import LoginForm from './LoginForm.vue';
  import ForgetPasswordForm from './ForgetPasswordForm.vue';
  import RegisterForm from './RegisterForm.vue';
  import { useDesign } from '/@/hooks/web/useDesign';
  import { useVisitLoginType, useLoginState, LoginStateEnum, visitLoginTypeEnum } from './useLogin';
  import { RouteLocationNormalizedLoaded } from 'vue-router';
  defineProps<{
    currentRoute: RouteLocationNormalizedLoaded;
  }>();
  const { prefixCls } = useDesign('login');
  const { setVisitLoginType } = useVisitLoginType();
  const { setLoginState } = useLoginState();

  setVisitLoginType(visitLoginTypeEnum.BY_MODAL);
  setLoginState(LoginStateEnum.CHECK_ACCOUNT_BEFORE_LOGIN);
</script>
<style lang="less">
  @step-start: 'start';
  @step-ing: 'ing';
  @step-end: 'end';
  @start-cls: ~'@{namespace}-step-@{step-start}';
  @ing-cls: ~'@{namespace}-step-@{step-ing}';
  @end-cls: ~'@{namespace}-step-@{step-end}';

  @prefix-cls: ~'@{namespace}-login';
  @logo-prefix-cls: ~'@{namespace}-app-logo';
  @countdown-prefix-cls: ~'@{namespace}-countdown-input';
  @dark-bg: @bg-color;
  @dark-input-bg: @component-bg-color;

  html[data-theme='dark'] {
    .@{prefix-cls} {
      background-color: @dark-bg;

      &::before {
        background-image: url(/@/assets/svg/login-bg-dark.svg);
      }

      .ant-input,
      .ant-input-password {
        background-color: @dark-input-bg;
      }

      .ant-btn:not(.ant-btn-link):not(.ant-btn-primary) {
        border: 1px solid #4a5569;
      }

      &-form {
        background: transparent !important;
      }

      .app-iconify {
        color: #fff;
      }

      .main-box {
        background: var(--color-background);
      }
    }

    input.fix-auto-fill,
    .fix-auto-fill input,
    .ant-input-affix-wrapper > input.ant-input {
      &:-webkit-autofill {
        border: none;
        box-shadow: inset 0 0 0 1000px @component-bg-color !important; // 改变了背景色
        -webkit-text-fill-color: @text-color-88 !important; // 改变了字体颜色
        background-clip: text;
      }
    }
  }

  .@{start-cls},
  .@{ing-cls},
  .@{end-cls} {
    color: #fff !important;
  }
  .@{prefix-cls} {
    min-height: 100%;
    overflow: hidden;

    @media (max-width: @screen-xl) {
      background-color: @dark-bg;

      .@{prefix-cls}-form {
        background-color: #fff;
      }
    }

    .ant-input-affix-wrapper {
      border-color: rgba(0, 0, 0, 0);
    }

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      margin-left: -48%;
    }

    .@{logo-prefix-cls} {
      &__title {
        font-size: 16px;
        color: #fff;
      }

      img {
        width: 32px;
      }
    }

    .main-box {
      background: linear-gradient(180deg, @light-color 0%, rgba(222, 250, 245, 0) 100%);
      .@{logo-prefix-cls} {
        display: flex;
        width: 60%;
        height: 153px;
        margin-left: -0.625rem;

        &__title {
          font-size: 24px;
          color: #fff;
        }

        img {
          width: 153px;
        }
      }
    }

    &-sign-in-way {
      .anticon {
        font-size: 22px;
        color: #888;
        cursor: pointer;

        &:hover {
          color: @primary-color;
        }
      }
    }

    input:not([type='checkbox']) {
      @media (max-width: @screen-xl) {
        min-width: 320px;
      }

      @media (max-width: @screen-lg) {
        min-width: 260px;
      }

      @media (max-width: @screen-md) {
        min-width: 240px;
      }

      @media (max-width: @screen-sm) {
        min-width: 160px;
      }
    }

    .@{countdown-prefix-cls} input {
      min-width: unset;
    }

    .ant-divider-inner-text {
      font-size: 12px;
      color: @text-color-secondary;
    }
  }
</style>
